<template>
  <div v-if="errorMessage" class="content alert alert-danger" role="alert">
    <h4 class="alert-heading">An error has occured</h4>
    <p>{{ errorMessage }}</p>
  </div>
  <div
    v-if="!dataReady && !errorMessage"
    class="content w-full d-flex justify-content-center"
  >
    <img src="@/assets/img/spinner.gif" alt="Loading..." />
  </div>
  <div v-if="dataReady" class="content">
    <div class="d-flex flex-row">
      <h1 class="content-title flex-grow-1">{{ event.name }}</h1>
      <router-link class="btn btn-secondary" :to="`/gifts/new/${event.id}`">
        <i class="fas fa-plus"></i>
        <span class="ml-5">New Gift</span>
      </router-link>
    </div>
    <div v-if="gifts.length == 0" class="content">
      <p class="text-xl">
        This event doesn't appear to have any gifts in it yet. Either create
        your own gift using the button above, in the "New Gifts" menu or wait
        for others to create gifts for this event.
      </p>
    </div>
    <details class="card p-0 m-10 mx-20 collapse-panel">
      <!-- w-400 = width: 40rem (400px), mw-full = max-width: 100% -->
      <summary class="collapse-header">
        Filter
      </summary>
      <div class="collapse-content">
        <label for="ownerId">Show gifts for</label>
        <select v-model="ownerId" class="form-control" id="ownerId">
          <option value="" selected="selected">Everyone</option>
          <option
            v-for="owner in uniqueGiftOwners"
            :key="owner.id"
            :value="owner.id"
            @change="filterList()"
            >{{ owner.name }}</option
          >
        </select>
      </div>
    </details>
  </div>
  <div
    v-for="gift in filteredGifts"
    :key="gift.id"
    :data-id="gift.id"
    class="card p-10 m-10"
  >
    <div
      class="d-flex flex-column flex-md-row flex-fill align-items-left w-full"
    >
      <div class="d-flex flex-row flex-grow-1">
        <div
          class="w-100 h-100 object-cover object-center flex-shrink-0 align-self-start"
          :style="
            !gift.imageUrl
              ? {
                  backgroundImage: 'url(/img/present.jpg)',
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                }
              : ''
          "
        >
          <img
            v-if="gift.imageUrl"
            :src="gift.imageUrl"
            :alt="gift.name"
            class="w-100 h-100"
            style="object-fit: cover"
          />
        </div>
        <div class="d-flex flex-column flex-md-row flex-grow-1">
          <div class="content my-0 flex-grow-1 mx-10 mx-md-20 mb-10">
            <h2
              v-if="gift.owner"
              class="font-size-16 font-weight-semi-bold my-5"
            >
              {{ gift.name }}
            </h2>
            <p class="text-sm text-muted mb-0 my-5">
              {{ gift.owner.name ? gift.owner.name : gift.owner.email }}
            </p>
            <p class="text-sm text-muted mb-0 my-5">{{ gift.description }}</p>
          </div>
        </div>
      </div>
      <div
        class="content my-0 mx-0 d-flex flex-row flex-no-wrap align-self-end align-self-md-end align-items-end"
      >
        <a
          v-if="gift.linkUrl"
          :href="gift.linkUrl"
          class="btn btn-primary ml-5"
        >
          <i class="fas fa-link"></i>
          <span class="ml-5">Link</span>
        </a>
        <span v-if="gift.owner?.id == this.userId" class="">
          <!--i class="fas fa-question-circle"></i>
            <span class="ml-5">Hidden</span-->
        </span>
        <a
          v-else-if="gift.boughtBy?.id == this.userId"
          class="btn btn-secondary ml-5"
          @click="returnGift(gift)"
        >
          <i class="fas fa-undo"></i>
          <span class="ml-5">Return</span>
        </a>
        <a
          v-else-if="gift.boughtBy == null"
          class="btn btn-success ml-5"
          @click="buyGift(gift)"
        >
          <i class="fas fa-cart-plus"></i>
          <span class="ml-5">Buy</span>
        </a>
        <span v-else class="btn btn-muted ml-5 disabled">
          <i class="fas fa-times-circle"></i>
          <span class="ml-5">Bought</span>
        </span>
        <div class="dropdown">
          <button
            class="btn ml-5"
            data-toggle="dropdown"
            type="button"
            id="dropdown-toggle-btn-1"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <i class="fa fa-angle-down ml-5" aria-hidden="true"></i>
            <!-- ml-5 = margin-left: 0.5rem (5px) -->
          </button>
          <div
            v-if="userId == gift.owner.id"
            class="dropdown-menu dropdown-menu-right"
            aria-labelledby="dropdown-toggle-btn-1"
          >
            <router-link
              v-if="userId == gift.owner.id"
              class="ml-5 dropdown-item"
              :to="{
                name: 'EditGift',
                params: { eventId: this.eventId, giftId: gift.id },
              }"
              ><i class="fas fa-edit"></i
              ><span class="ml-5">Edit</span></router-link
            >
          </div>
        </div>
      </div>
    </div>
    <component v-if="dataReady" :is="event.type" />
  </div>
</template>

<script>
import { db, firebase } from "../../lib/firebase.js";
import Christmas from "../eastereggs/Christmas.vue";

export default {
  name: "Gifts",
  components: {
    Christmas,
  },
  props: ["eventId"],
  data() {
    return {
      event: null,
      gifts: [],
      dataReady: false,
      ownerId: "",
      giftsUnsub: null,
      errorMessage: null,
    };
  },
  computed: {
    userId: function() {
      return this.$store.getters.getUser.uid;
    },
    userName: function() {
      return this.$store.getters.getUser.displayName;
    },
    activeGifts: function() {
      return this.gifts.filter((gift) => {
        return gift.deleted != true;
      });
    },
    filteredGifts: function() {
      if (!this.ownerId) {
        return this.activeGifts;
      } else {
        return this.activeGifts.filter((gift) => {
          return gift.owner.id == this.ownerId;
        });
      }
    },
    uniqueGiftOwners: function() {
      const ids = [
        ...new Set(
          this.gifts.map((gift) => {
            return gift.owner.id;
          })
        ),
      ];
      const names = [
        ...new Set(
          this.gifts.map((gift) => {
            return gift.owner.name;
          })
        ),
      ];
      return ids.map((id, index) => {
        return { id: id, name: names[index] };
      });
    },
  },
  methods: {
    async getEvent(eventId) {
      try {
        const eventRef = db.collection("events").doc(eventId);
        const doc = await eventRef.get();
        var event = doc.data();
        event.id = doc.id;
        return event;
      } catch (error) {
        this.errorMessage = error.message;
        return null;
      }
    },
    async getGifts(eventId) {
      try {
        const eventRef = db.collection("events").doc(eventId);
        this.giftsUnsub = await eventRef
          .collection("gifts")
          .orderBy("name")
          .onSnapshot((querySnapshot) => {
            this.dataReady = true;
            querySnapshot.docChanges().forEach((change) => {
              if (change.type === "added") {
                this.gifts.splice(change.newIndex, 0, {
                  ...change.doc.data(),
                  ...{ id: change.doc.id },
                });
              }
              if (change.type === "modified") {
                this.gifts.splice(change.oldIndex, 1);
                this.gifts.splice(change.newIndex, 0, {
                  ...change.doc.data(),
                  ...{ id: change.doc.id },
                });
              } else if (change.type === "removed") {
                this.gifts.splice(change.oldIndex, 1);
              }
            });
          });
      } catch (error) {
        this.errorMessage = error.message;
        return null;
      }
    },
    async buyGift(gift) {
      const eventRef = db.collection("events").doc(this.eventId);
      await eventRef
        .collection("gifts")
        .doc(gift.id)
        .update({
          boughtBy: {
            id: this.userId,
            name: this.userName,
            modified: firebase.firestore.FieldValue.serverTimestamp(),
          },
        });
      window.analytics.track("Gift bought", {
        gift: gift,
      });
      firebase.analytics().logEvent("gift_bought");
    },
    async returnGift(gift) {
      const eventRef = db.collection("events").doc(this.eventId);
      await eventRef
        .collection("gifts")
        .doc(gift.id)
        .update({
          boughtBy: firebase.firestore.FieldValue.delete(),
          modified: firebase.firestore.FieldValue.serverTimestamp(),
        });
      window.analytics.track("Gift returned", {
        gift: gift,
      });
      firebase.analytics().logEvent("gift_returned");
    },
    getImgUrl(pic) {
      return require("../../assets/img/" + pic + ".jpg");
    },
  },
  async mounted() {
    this.event = await this.getEvent(this.eventId);
    await this.getGifts(this.eventId);
    document.querySelector("title").innerHTML = `GiftSift - ${this.event.name}`;
    document
      .querySelector('meta[name="description"]')
      .setAttribute("content", this.event.description);
    document
      .querySelector('meta[property="og:title"]')
      .setAttribute("content", `GiftSift - ${this.event.name}`);
    document
      .querySelector('meta[property="og:description"]')
      .setAttribute("content", this.event.description);
    document
      .querySelector('meta[property="og:url"]')
      .setAttribute("content", document.location);
    document
      .querySelector('meta[property="og:image"]')
      .setAttribute(
        "content",
        `${document.location.origin}/img/icons/android-icon-96x96.png`
      );
  },
  async beforeUnmount() {
    this.giftsUnsub();
  },
};
</script>

<style scoped></style>
